import { render, staticRenderFns } from "./NewEventFacultyCard.vue?vue&type=template&id=25af6639"
import script from "./NewEventFacultyCard.vue?vue&type=script&lang=js"
export * from "./NewEventFacultyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports